export default __webpack_public_path__ + "static/summer_containers85-c83fa8379c114d27838fcddfbd2e06d7.webp";